var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("\n  "+_vm._s(_vm.parseTranslation(_vm.QUESTION_ANSWERED, _vm.question_result.count))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }